@if (navigationConfiguration) {
	@if (layoutService.breakpoint | async; as breakpoint) {
		@if (isClipboardOpen(navigationConfiguration)) {
			<div
				id="clipboard"
				class="nav-drawer animate"
				[ngClass]="{ visible: isNavigationDrawerOpen(breakpoint), hide: !isNavigationDrawerOpen(breakpoint) }"
				animate.enter="stages-slide-in-from-bottom"
				animate.leave="stages-slide-out-to-bottom"
			>
				@if (getCurrentActions(navigationConfiguration); as currentActions) {
					<header class="main paste">
						<button
							[attr.title]="'close' | translate"
							[attr.aria-label]="'close' | translate"
							class="action"
							(click)="currentActions[0].on()"
						>
							<i class="ico ico-close"></i>
						</button>
						<div class="title">
							<span class="h5" translate="clipboard"></span>
							<span class="counter">{{ getElementCount(navigationConfiguration) }}</span>
							<span class="h6" translate="clipboard.destination"></span>
						</div>
						<button
							class="button sm save"
							translate="paste"
							(click)="currentActions[1].on()"
							[disabled]="inProgress || currentActions[1].disabled()"
						></button>
					</header>
				}
				@if (inProgress) {
					<div class="progress">
						<div class="indeterminate"></div>
					</div>
				}
				@if (isWorkspaceNavEnabled(navigationConfiguration) || isUpEnabled(navigationConfiguration)) {
					<header class="main buttons nav">
						@if (isWorkspaceNavEnabled(navigationConfiguration)) {
							<button
								[attr.title]="'navigation.workspace.select' | translate"
								[attr.aria-label]="'navigation.workspace.select' | translate"
								class="action workspace-icon"
								role="button"
								(click)="toggleWorkspaceNavigation()"
							>
								<i class="ico ico-workspace"></i>
							</button>
						}
						@if (isUpEnabled(navigationConfiguration)) {
							<button
								[attr.title]="'up' | translate"
								[attr.aria-label]="'up' | translate"
								class="action"
								[routerLink]="getRouterLink($any(navigationConfiguration.parentRoute), navigationConfiguration)"
								queryParamsHandling="preserve"
								role="button"
							>
								<i class="ico ico-arrow-up"></i>
							</button>
						}
					</header>
				}
				@if (workspaceNavigationOpen) {
					<div class="animate defer">
						@if (navigationConfiguration.clipboardConfiguration.workspaceFilter; as workspaceFilter) {
							<stages-workspace-selection
								(selectWorkspace)="onSelectWorkspace($event, navigationConfiguration)"
								[filterBy]="navigationConfiguration.clipboardConfiguration.workspaceFilter.filterBy"
								[filterParam1]="navigationConfiguration.clipboardConfiguration.workspaceFilter.filterParam1"
								[filterParam2]="navigationConfiguration.clipboardConfiguration.workspaceFilter.filterParam2"
							>
							</stages-workspace-selection>
						} @else {
							<stages-workspace-selection (selectWorkspace)="onSelectWorkspace($event, navigationConfiguration)">
							</stages-workspace-selection>
						}
					</div>
				}
				<div
					class="main-navigation"
					[ngClass]="{
						visible: !workspaceNavigationOpen,
						'has-toolbar': isWorkspaceNavEnabled(navigationConfiguration) || isUpEnabled(navigationConfiguration),
					}"
				>
					<div class="wrapper">
						<nav>
							<div class="wrapper">
								@if (navigationConfiguration.folder) {
									<ul class="list navigation folder">
										@for (folder of $any([navigationConfiguration.folder]); track trackById($index, folder)) {
											<li
												class="list-item"
												[class.active]="isRouterLinkActive(folder.route, folder.exact === true)"
												id="clipItem{{ folder.id }}"
											>
												<a
													class="label"
													[routerLink]="getRouterLink(folder.route, navigationConfiguration)"
													queryParamsHandling="preserve"
												>
													@switch (folder.entryType) {
														@case ("single-line") {
															<stages-navigation-entry-single-line
																class="label"
																[entry]="folder"
																[mode]="folder.displayMode"
															></stages-navigation-entry-single-line>
														}
														@case ("two-line") {
															<stages-navigation-entry-two-line
																class="label"
																[entry]="folder"
																[mode]="folder.displayMode"
															></stages-navigation-entry-two-line>
														}
														@case ("two-line-split-rating") {
															<stages-navigation-entry-two-line-split-rating
																class="label"
																[entry]="folder"
																[mode]="folder.displayMode"
															></stages-navigation-entry-two-line-split-rating>
														}
														@default {
															<stages-navigation-entry-single-line
																class="label"
																[entry]="folder"
																[mode]="folder.displayMode"
															></stages-navigation-entry-single-line>
														}
													}
												</a>
											</li>
										}
										@if (
											$any(navigationConfiguration.folder).children !== undefined &&
											hasOmmittedEntries($any(navigationConfiguration.folder).children)
										) {
											<div class="label ommitted-items">
												<div class="text fullsize dark">
													<span class="h3" translate="list.items.ommitted"></span>
												</div>
											</div>
										}
									</ul>
								}
								@if (navigationConfiguration) {
									<ul class="list navigation">
										@for (
											element of $any(getVisibleNavigationEntries(navigationConfiguration.list));
											track trackById($index, element)
										) {
											<li
												class="list-item"
												[class.active]="isRouterLinkActive(element.route, element.exact === true)"
												id="clipItem{{ element.id }}"
											>
												<a
													class="label"
													[routerLink]="getRouterLink(element.route, navigationConfiguration)"
													queryParamsHandling="preserve"
												>
													@switch (element.entryType) {
														@case ("single-line") {
															<stages-navigation-entry-single-line
																class="fullsize"
																[entry]="element"
																[mode]="element.displayMode"
															></stages-navigation-entry-single-line>
														}
														@case ("two-line") {
															<stages-navigation-entry-two-line
																class="fullsize"
																[entry]="element"
																[mode]="element.displayMode"
															></stages-navigation-entry-two-line>
														}
														@case ("two-line-split-rating") {
															<stages-navigation-entry-two-line-split-rating
																class="fullsize"
																[entry]="element"
																[mode]="element.displayMode"
															></stages-navigation-entry-two-line-split-rating>
														}
														@default {
															<stages-navigation-entry-single-line
																class="fullsize"
																[entry]="element"
																[mode]="element.displayMode"
															></stages-navigation-entry-single-line>
														}
													}
												</a>
											</li>
										}
										@if (hasOmmittedEntries($any(navigationConfiguration).folder.original.children)) {
											<div class="label ommitted-items">
												<div class="text fullsize light">
													<span class="h3" translate="list.items.ommitted"></span>
												</div>
											</div>
										}
									</ul>
								}
							</div>
						</nav>
					</div>
				</div>
			</div>
		}
	}
}
